import { Link, MessageBar, MessageBarBody } from '@fluentui/react-components';

export const DATA_LAKE_ENTITLEMENT_REQUIRED_MESSAGE =
  'Data Lake access requires the capevalsdata-cxcv entitlement.';

export const DATA_LAKE_ENTITLEMENT_URL =
  'https://coreidentity.microsoft.com/manage/entitlement/entitlement/capevalsdata-cxcv';

export function isDataLakeEntitlementRequiredMessage(message: string): boolean {
  return message === DATA_LAKE_ENTITLEMENT_REQUIRED_MESSAGE;
}

export function DataLakeEntitlementGuidance() {
  return (
    <MessageBar intent="warning">
      <MessageBarBody>
        Data Lake access is required for this workspace.{' '}
        <Link href={DATA_LAKE_ENTITLEMENT_URL} target="_blank" rel="noreferrer">
          Request the capevalsdata-cxcv entitlement
        </Link>
        .
      </MessageBarBody>
    </MessageBar>
  );
}
